import { Component, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';

@Component({
  selector: 'san-additional-abrechnungs-email',
  standalone: false,
  templateUrl: './additional-abrechnungs-email.component.html',
  styleUrl: './additional-abrechnungs-email.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdditionalAbrechnungsEmailComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AdditionalAbrechnungsEmailComponent),
      multi: true,
    },
  ],
})
export class AdditionalAbrechnungsEmailComponent
  implements ControlValueAccessor, Validator
{
  form: FormGroup;

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group(
      {
        email: [''],
        confirm: [false],
      },
      { validators: this.requireCheckboxIfEmail.bind(this) },
    );

    this.form.valueChanges.subscribe((value: { email: string }) => {
      this.onChange(value.email);
    });
  }

  writeValue(value: string): void {
    if (value) {
      this.form.patchValue(
        { email: value, confirm: true },
        { emitEvent: false },
      );
    } else {
      this.form.patchValue(
        { email: value, confirm: false },
        { emitEvent: false },
      );
    }
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  validate(_: AbstractControl): ValidationErrors | null {
    return this.form.valid ? null : { confirmationRequired: true };
  }

  requireCheckboxIfEmail(group: AbstractControl): ValidationErrors | null {
    const email = group.get('email')?.value as string;
    const confirm = group.get('confirm')?.value as string;

    if (email && !confirm) {
      return { confirmationRequired: true };
    }

    return null;
  }
}
